import { defineStore } from "pinia";
import _ from "lodash";
import router from "@/employee/routes";
import {
  BalanceTransferMethod,
  BalanceTransferState,
  BalanceTransferStepKey,
  RolloverBalanceTransferFormRequest,
  TrusteeToTrusteeBalanceTransferFormRequest
} from "@/shared/types";
import {
  generateRolloverBalanceTransferForm,
  generateTrusteeToTrusteeBalanceTransferForm
} from "@/shared/api/userService";
import * as storeHelper from "@/shared/storeHelper";
import {
  OnboardingBalanceTransfer as OnboardingBalanceTransferRouteName,
  Transfers as TransfersRouteName
} from "@/employee/route-names";
import { useUserBankAccountStore } from "@/shared/store/userBankAccount";

export const initialState: BalanceTransferState = {
  transferMethod: BalanceTransferMethod.None,
  rolloverDetails: {
    amount: 0
  },
  trusteeToTrusteeDetails: {
    trusteeAccountNumber: "",
    transferEntireBalance: false,
    transferPartialBalance: false,
    amount: 0
  },
  isOnboarding: false
};

export const useBalanceTransferStore = defineStore("balanceTransfer", {
  state: () => (_.cloneDeep(initialState)),
  actions: {
    generateTrusteeToTrusteeBalanceTransferForm () {
      let transferEntireBalance: boolean = null;

      if (this.trusteeToTrusteeDetails.transferEntireBalance) {
        transferEntireBalance = true;
      } else if (this.trusteeToTrusteeDetails.transferPartialBalance) {
        transferEntireBalance = false;
      }

      const userBankAccountStore = useUserBankAccountStore();
      const request: TrusteeToTrusteeBalanceTransferFormRequest = {
        trusteeAccountNumber: this.trusteeToTrusteeDetails.trusteeAccountNumber,
        transferEntireBalance,
        amount: this.trusteeToTrusteeDetails.amount > 0 ? this.trusteeToTrusteeDetails.amount : null,
        hsaBankAccountNumber: userBankAccountStore.accountNumber
      };

      return generateTrusteeToTrusteeBalanceTransferForm(request)
        .then(response => response.data)
        .catch(error => storeHelper.handleError({ error, rethrow: true }));
    },
    generateRolloverBalanceTransferForm () {
      const userBankAccountStore = useUserBankAccountStore();
      const request: RolloverBalanceTransferFormRequest = {
        amount: this.rolloverDetails.amount > 0 ? this.rolloverDetails.amount : null,
        hsaBankAccountNumber: userBankAccountStore.accountNumber
      };

      return generateRolloverBalanceTransferForm(request)
        .then(response => response.data)
        .catch(error => storeHelper.handleError({ error, rethrow: true }));
    },
    clearState () {
      this.transferMethod = BalanceTransferMethod.None;
      this.rolloverDetails = { amount: 0 };
      this.trusteeToTrusteeDetails = {
        trusteeAccountNumber: "",
        transferEntireBalance: false,
        transferPartialBalance: false,
        amount: 0
      };
    },
    goToStep (stepKey?: BalanceTransferStepKey) {
      const routeName = this.isOnboarding ? OnboardingBalanceTransferRouteName : TransfersRouteName;

      return router.push({
        name: routeName,
        params: {
          stepKey
        }
      });
    },
    goToStart () {
      this.goToStep();
    }
  }
});
